<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Crear frecuencia">
          <frequency-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import FrequencyForm from "@/components/Forms/FrequencyForm.vue";
import CCard from "@/components/CCard.vue";
export default {
  components: {
    FrequencyForm,
    CCard,
  },
};
</script>
